const NUMERATION = 'numerar';
const DATE = 'fechar';

export default {
  NUMERATION,
  DATE,
};

export const OFICE_ACTION = [
  NUMERATION,
  DATE,
];
